module.exports = __webpack_public_path__ + "fonts/SofiaProSemiBold.797cfcd2.ttf";